import React, { useEffect, useState } from "react";
import { Box, Button, Heading, Image, ResponsiveContext, Spinner, Text, Anchor, Grid, Markdown } from "grommet";
import { CaretLeftFill, Home, Like, LikeFill, Location, Magic, Trophy } from "grommet-icons";
import axios from "axios";
import { Attendee, useUser } from "../utils/AccountStore";
import { Exhibitor } from "./Exhibitors";
import { useNavigate, useParams } from "react-router-dom";

export const GetExhibitor = async (id: string) => {
    return axios.get(`${Server}/api/exhibitors/${id}`);
};

const ExhibitorDetails = () => {
    const { id } = useParams();
    const [exhibitor, setExhibitor] = useState({} as Exhibitor);
    const { user, getUser } = useUser();
    const [isFavorite, setIsFavorite] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            GetExhibitor(id)
                .then((res) => {
                    if (res.status === 200) {
                        setExhibitor(res.data);
                    } else {
                        alert("Error getting exhibitor");
                        navigate("home");
                    }
                })
                .catch(() => {
                    alert("Error getting exhibitor");
                    navigate("home");
                });
        }
    }, [id]);

    useEffect(() => {
        if (user.id) {
            setIsFavorite(user.favorites.includes(exhibitor.id));
        }
    }, [user, exhibitor]);

    const toggleFavorite = async () => {
        await axios.post(`${Server}/api/attendees/toggleFavorite`, {
            userID: user.id,
            exhibitorID: exhibitor.id,
        });
        getUser();
    };

    return (
        <ResponsiveContext.Consumer>
            {(size) => (
                <Box pad="medium" align="center" width="100%">
                    {!exhibitor.id ? (
                        <Spinner />
                    ) : (
                        <Box width="xlarge" gap="small">
                            <Grid columns={["1fr", "auto", "1fr"]} width="100%" align="center">
                                <Home color="brand" onClick={() => navigate("/home")} />
                                <Heading color="brand" level="3" margin="none" weight={"bold"}>
                                    {exhibitor.name}
                                </Heading>
                                <Box align="end">
                                    <Button icon={isFavorite ? <LikeFill color="brand" /> : <Like color="text" />} onClick={toggleFavorite} />
                                </Box>
                            </Grid>
                            <Box>
                                <Box background={{ image: "url(/images/background.png)" }} align="center" style={{ maxHeight: "50vh" }} round="small">
                                    <Box round="small">
                                        <Image src={exhibitor.logo} fit="contain" alt={`${exhibitor.name} Logo`} />
                                    </Box>
                                </Box>

                                {/* {exhibitor.isTreasure && (
                                <Box direction="row" align="center" gap="small">
                                    <Text color="brand">{exhibitor.name} is part of the Product Experience!</Text>
                                </Box>
                            )} */}

                                <Box pad={"medium"} background={"white"} border={{ color: "brand", size: "3px" }} round="small" width="100%">
                                    {exhibitor.location && (
                                        <Box direction="row" align="center" gap="small">
                                            <Text weight="bold">{exhibitor.location}</Text>
                                        </Box>
                                    )}

                                    {exhibitor.website && (
                                        <Box>
                                            <Anchor href={exhibitor.website} target="_blank" weight={"bold"}>
                                                {exhibitor.website}
                                            </Anchor>
                                        </Box>
                                    )}

                                    <Box>
                                        <Markdown>{exhibitor.description}</Markdown>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </Box>
            )}
        </ResponsiveContext.Consumer>
    );
};

export default ExhibitorDetails;
